const OBUOperatorManagement = () => {
  return <>Operator Management</>
}

export default OBUOperatorManagement;